import { render, staticRenderFns } from "./GoodsCon.vue?vue&type=template&id=61b25bed&scoped=true"
import script from "./GoodsCon.vue?vue&type=script&lang=js"
export * from "./GoodsCon.vue?vue&type=script&lang=js"
import style0 from "./GoodsCon.vue?vue&type=style&index=0&id=61b25bed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b25bed",
  null
  
)

export default component.exports